import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function CookiesPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Cookie Policy"
        description="JumpstoneAuth Cookie Policy. Learn about the cookies we use and how to manage your preferences."
        canonical="/cookies"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <h1 className="text-4xl font-bold text-white mb-4">Cookie Policy</h1>
          <p className="text-lg text-surface-400">Last updated: January 2026</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}

